'use client';

import { useState } from 'react';
import Image from 'next/image';
import { DELETEv1RemoveProduct, POSTv1AddProduct } from '@/api/member';
import { PUBLIC } from '@/constants/image/path';
import { QuotesCodeMapping } from '@/constants/quote/quote';
import { GTMEventKey, CustomEventName, sendGTM } from '@/utils/gtm';
import { type CellContext } from '@tanstack/react-table';

const Save = ({
  symbol,
  isUserSave,
  gtmEvent
}: {
  symbol: string;
  isUserSave: boolean;
  gtmEvent?: {
    [GTMEventKey.EVENT_NAME]: CustomEventName;
    [GTMEventKey.SECTION]: string;
  };
}) => {
  const [isSave, setIsSave] = useState(isUserSave);

  const onClick = async (e: React.MouseEvent) => {
    e.stopPropagation();

    if (gtmEvent) {
      sendGTM({ ...gtmEvent, [GTMEventKey.LABEL]: isSave?.toString() });
    }

    if (isSave) {
      await DELETEv1RemoveProduct({ productId: symbol, groupIds: [1, 2, 3, 4] });
    } else {
      await POSTv1AddProduct({ productId: symbol, groupIds: [1] });
    }

    setIsSave(v => !v);
  };

  return isSave ? (
    <Image src={`${PUBLIC}/icons/star/star.svg`} alt='save-icon' width={20} height={20} onClick={onClick} />
  ) : (
    <Image src={`${PUBLIC}/icons/star/star-empty.svg`} alt='save-icon' width={20} height={20} onClick={onClick} />
  );
};

export const saveColumn = (
  userSaveList: string[],
  gtmEvent?: {
    [GTMEventKey.EVENT_NAME]: CustomEventName;
    [GTMEventKey.SECTION]: string;
  }
) => ({
  accessorKey: QuotesCodeMapping.SYMBOL.toString(),
  header: () => <div className='text-nowrap text-left'>自選</div>,
  size: 30,
  cell: (props: CellContext<any, string>) => {
    const symbol = props?.row?.original?.[QuotesCodeMapping.SYMBOL];
    const isUserSave = userSaveList?.includes(symbol);

    return <Save symbol={symbol} isUserSave={isUserSave} gtmEvent={gtmEvent} />;
  },
  enableSorting: false
});
